import React, { useEffect } from "react";
import "./App.css";
import { mainFunctions } from "./main";
import PortfolioCard from "./components/PortfolioCard";
import portfolioData from "./components/_portfolios";

function App() {
  useEffect(() => {
    if (window.$ && window.VANTA) {
      const jQ = window.$;
      const vanta = window.VANTA;
      mainFunctions(jQ, vanta);
    }
  }, []);

  return (
    <div className="App">
      <div id="pagepiling" className="vantaBg">
        {/* <!-- Start Preloader --> */}
        <div className="preloader">
          <div className="preloader-img"></div>
        </div>
        {/* <!-- End Preloader --> */}

        {/* <!--Start Header--> */}
        <header>
          <div className="logo-area">
            <a href="/" className="logo">
              {/* <img src="web/images/logo.png" alt="logo" /> */}
              王旭梅
            </a>
          </div>
          <div className="header-info-area">
            <a className="info-btn" id="header-info-btn" href="#header-info-bar">
              <span className="top"></span>
              <span className="middle"></span>
              <span className="bottom"></span>
            </a>
            <div id="header-info-bar">
              <div className="close-animatedModal close-header-info-bar">
                <i className="fas fa-times"></i>
              </div>
              <div className="modal-content">
                <nav className="menu" id="menu">
                  <ul id="mainMenu">
                    <li data-menuanchor="home" className="active">
                      <a href="#home">Home</a>
                    </li>
                    <li data-menuanchor="about">
                      <a href="#about">About</a>
                    </li>
                    <li data-menuanchor="skills">
                      <a href="#about">Skills</a>
                    </li>
                    <li data-menuanchor="service">
                      <a href="#service">Services</a>
                    </li>
                    <li data-menuanchor="portfolio">
                      <a href="#portfolio">Portfolio</a>
                    </li>
                    <li data-menuanchor="client-testimonial">
                      <a href="#client-testimonial">Testimonial</a>
                    </li>
                    {/* <li data-menuanchor="blog">
                      <a href="#blog">Blog</a>
                    </li> */}
                    <li data-menuanchor="contact">
                      <a href="#contact">Contact</a>
                    </li>
                  </ul>
                </nav>
                {/* <!--Start Newsletter area--> */}
                <div className="newsletter" id="newsletter">
                  <div className="container">
                    <div className="row">
                      <h5>Get Updates:</h5>
                      <div className="newsletter-form">
                        <form id="mc-form">
                          <input
                            type="email"
                            id="mc-email"
                            className="newsletter-email"
                            placeholder="Type your email here"
                          />
                          <button type="submit" className="submit-btn">
                            <span>Subscribe</span>
                          </button>
                          <label htmlFor="mc-email"></label>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!--End Newsletter area--> */}
              </div>
            </div>
          </div>
        </header>
        {/* <!--End Header--> */}

        {/* <!--Start Welcome Section--> */}
        <section
          className="welcome-area home animated-text section pp-scrollable"
          id="welcome-area"
        >
          <div className="vanta-bg waves" id="welcome-vanta-area">
            <div className="content-container">
              <div className="overlayImg"></div>
              <div className="title-small">
                <p>HOME</p>
              </div>
              <div className="display-table about">
                <div className="display-content">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="welcome-text">
                          <h6 style={{ color: "#fff" }}>
                            I'm <span>Xumei Wang</span>
                          </h6>
                          <div className="type-wrap">
                            <div id="typed-strings">
                              <h1>
                                <span>A Software Engineer</span>
                              </h1>
                              <h1>
                                <span>A Web Developer</span>
                              </h1>
                              <h1>
                                <span>A Mobile Developer</span>
                              </h1>
                            </div>
                            <span id="typed"></span>
                          </div>
                          <p>
                            Are you looking for developer with both high-end coding skills and
                            resourceful UI knowledge?
                            <br />
                            Are you seeking a contributor as well as problem solver?
                            <br />
                            Are you searching for contractor without labor burdens?
                            <br /> Here I am.
                          </p>
                          {/* <div className="social-icons">
                            <a
                              href="https://www.linkedin.com/in/don-z-24b3621b2/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="fab fa-linkedin"></i>
                            </a>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!--End Welcome Section--> */}

        {/* Start About Section */}
        <section className="about section pp-scrollable" id="about">
          <div className="about-header">
            <div className="title-small">
              <p>ABOUT ME</p>
            </div>
          </div>
          <div className="content-container">
            <div className="display-table">
              <div className="display-content">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 col-md-12">
                      <div className="about-content">
                        <h4 className="section-title summary-title">
                          My career as a Software Engineer
                        </h4>
                        <p className="about-text summary-content">
                          As far as I can remember, I have always admired the potential for
                          technology and have been interested in learning more about it. After
                          starting teamwork and freelancing, I had the opportunity to meet and speak
                          with a number of tech professionals, and I got inspired by their ability
                          to turn ideas into reality. At the same time, I started confirming the
                          possibility of myself doing the same thing: creating things I could only
                          imagine.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12">
                      <h4 className="section-title summary-title">About Me</h4>
                      <div className="contact-detail about-content-custom">
                        <p className="phone">
                          <span>Hello, I'm Xumei Wang (王旭梅)</span>
                        </p>
                        {/* <p className="phone">
                          <span>DEGREE:</span>Master of Science (MS)
                        </p>
                        <p className="phone">
                          <span>PHONE:</span>+1 (807)789-3053
                        </p>
                        <p className="phone">
                          <span>SKYPE:</span>live:.cid.593c3342eaf7fb75
                        </p> */}
                        <p className="phone">
                          <span>PHONE:</span>+86 18834122285
                        </p>
                        <p className="email">
                          <span>EMAIL:</span>wangxm19950605@163.com
                        </p>
                        <p className="adress">
                          <span>Location:</span>
                          <span className="adress-loc">China</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End About Section */}

        {/* <!--Start Skill Section--> */}
        <section className="about section pp-scrollable" id="skills">
          <div className="about-header">
            <div className="title-small">
              <p>SKILLS</p>
            </div>
          </div>
          <div className="content-container">
            <div className="display-table">
              <div className="display-content">
                <div className="container">
                  <div className="row">
                    {/* <div className="col-lg-5 col-md-12">
                      <div className="about-img">
                        <img src="web/images/about.jpg" alt="" className="img-responsive" />
                        <div className="img-hover">
                          <a href="#">Download my CV</a>
                        </div>
                        <div className="img-overlay"></div>
                      </div>
                    </div> */}
                    <div className="col-lg-6 col-md-12">
                      <div className="skills">
                        <div className="progressbar-area">
                          <h6>Javascript / Typescript</h6>
                          <div className="progress">
                            <div
                              className="progress-bar prog1"
                              role="progressbar"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                              data-progress="100%"
                            >
                              <span>100%</span>
                            </div>
                          </div>

                          <h6>React / Redux / Gatsby / Next.js</h6>
                          <div className="progress">
                            <div
                              className="progress-bar prog2"
                              role="progressbar"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                              data-progress="100%"
                            >
                              <span>100%</span>
                            </div>
                          </div>

                          <h6>Angular 2+ / AnglarJS / Ngrx / RxJS</h6>
                          <div className="progress">
                            <div
                              className="progress-bar prog3"
                              role="progressbar"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                              data-progress="100%"
                            >
                              <span>100%</span>
                            </div>
                          </div>
                          <h6>Vue.js / Vuex / Nuxt.js</h6>
                          <div className="progress">
                            <div
                              className="progress-bar prog4"
                              role="progressbar"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                              data-progress="100%"
                            >
                              <span>100%</span>
                            </div>
                          </div>
                          <h6>D3.js / Recharts / HighCharts / Chart.js</h6>
                          <div className="progress">
                            <div
                              className="progress-bar prog5"
                              role="progressbar"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                              data-progress="100%"
                            >
                              <span>100%</span>
                            </div>
                          </div>
                          <h6>HTML/HTML5, CSS/CSS3, SCSS, SASS, LESS</h6>
                          <div className="progress">
                            <div
                              className="progress-bar prog6"
                              role="progressbar"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                              data-progress="100%"
                            >
                              <span>100%</span>
                            </div>
                          </div>
                          <h6>Chrome Extension</h6>
                          <div className="progress">
                            <div
                              className="progress-bar prog7"
                              role="progressbar"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                              data-progress="100%"
                            >
                              <span>100%</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className="about-content">
                        <div className="skills">
                          <div className="progressbar-area">
                            <h6>React Native / Expo</h6>
                            <div className="progress">
                              <div
                                className="progress-bar prog8"
                                role="progressbar"
                                aria-valuenow="100"
                                aria-valuemin="0"
                                aria-valuemax="100"
                                data-progress="100%"
                              >
                                <span>100%</span>
                              </div>
                            </div>
                            <h6>Flutter / Dart</h6>
                            <div className="progress">
                              <div
                                className="progress-bar prog9"
                                role="progressbar"
                                aria-valuenow="95"
                                aria-valuemin="0"
                                aria-valuemax="100"
                                data-progress="95%"
                              >
                                <span>95%</span>
                              </div>
                            </div>
                            <h6>NodeJS / ExpressJS / NestJS</h6>
                            <div className="progress">
                              <div
                                className="progress-bar prog10"
                                role="progressbar"
                                aria-valuenow="90"
                                aria-valuemin="0"
                                aria-valuemax="100"
                                data-progress="90%"
                              >
                                <span>90%</span>
                              </div>
                            </div>
                            <h6>Shopify / Shopify Plus / Liquid</h6>
                            <div className="progress">
                              <div
                                className="progress-bar prog12"
                                role="progressbar"
                                aria-valuenow="95"
                                aria-valuemin="0"
                                aria-valuemax="100"
                                data-progress="95%"
                              >
                                <span>95%</span>
                              </div>
                            </div>
                            <h6>Python / Django / Flask</h6>
                            <div className="progress">
                              <div
                                className="progress-bar prog11"
                                role="progressbar"
                                aria-valuenow="90"
                                aria-valuemin="0"
                                aria-valuemax="100"
                                data-progress="90%"
                              >
                                <span>90%</span>
                              </div>
                            </div>
                            
                            <h6>Ruby on Rails</h6>
                            <div className="progress">
                              <div
                                className="progress-bar prog13"
                                role="progressbar"
                                aria-valuenow="85"
                                aria-valuemin="0"
                                aria-valuemax="100"
                                data-progress="85%"
                              >
                                <span>85%</span>
                              </div>
                            </div>
                            <h6>AWS / Firebase / PostgreSQL / MySQL / MongoDB</h6>
                            <div className="progress">
                              <div
                                className="progress-bar prog14"
                                role="progressbar"
                                aria-valuenow="85"
                                aria-valuemin="0"
                                aria-valuemax="100"
                                data-progress="90%"
                              >
                                <span>90%</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!--End About Section--> */}

        {/* <!--Start Services Section--> */}
        {/* <section className="service section pp-scrollable" id="service">
          <div className="content-container">
            <div className="display-table">
              <div className="display-content">
                <div className="service-header">
                  <div className="title-small">
                    <p>My SERVICES</p>
                  </div>
                  <h4 className="section-title">What I Offer</h4>
                </div>
                <div className="service-content">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="service-item">
                          <span>
                            <i className="fas fa-lightbulb"></i>
                          </span>
                          <p className="content-title">WEB DEVELOPMENT</p>
                          <p className="content-text">
                            Providing both frontend and backend development with modern javascript
                            frameworks and MVC etc.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="service-item">
                          <span>
                            <i className="fas fa-pencil-ruler"></i>
                          </span>
                          <p className="content-title">MOBILE APP DEVELOPMENT</p>
                          <p className="content-text">
                            Providing Native mobile app and Hybrid mobile app developments for Cross
                            platform IOS, Android, Windows phone.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="service-item">
                          <span>
                            <i className="fas fa-laptop-code"></i>
                          </span>
                          <p className="content-title">WEB DESIGN</p>
                          <p className="content-text">
                            Providing web design based on the client's business logic and idea.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="service-item">
                          <span>
                            <i className="fas fa-pen-nib"></i>
                          </span>
                          <p className="content-title">DATA VISUALIZATION DEVELOPMENT</p>
                          <p className="content-text">
                            Providing custom charts like line, area, bar chart, scatter chart,
                            sunburst and implementing analytics/report, data visualization dashboard
                            using D3.js, High charts, Amcharts, etc Providing custom 3D and 2D data
                            visualization
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="service-item">
                          <span>
                            <i className="fas fa-headphones"></i>
                          </span>
                          <p className="content-title">
                            CHROME, FIREFOX, SAFARI EXTENSION DEVELOPMENT
                          </p>
                          <p className="content-text">
                            Providing Chrome, Firefox, Safari extension with javascript and modern
                            javascript framework like React, Vue, and Swift
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="service-item">
                          <span>
                            <i className="fas fa-hammer"></i>
                          </span>
                          <p className="content-title">WEB SCRAPPING DEVELOPMENT</p>
                          <p className="content-text">
                            Providing web scrapping with scrapping libraries and framework like
                            BeautifulSoup, Requests, Selenium, Scrapy, Puppeteer, etc
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <section className="service section pp-scrollable" id="service">
          <div className="content-container">
            <div className="display-table">
              <div className="display-content">
                <div className="service-header">
                  <div className="title-small">
                    <p>My SERVICES</p>
                  </div>
                  <h4 className="section-title">What I Offer</h4>
                </div>
                <div className="service-content">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="service-item">
                          <span>
                            <i className="fas fa-lightbulb"></i>
                          </span>
                          <p className="content-title">Concept & Strategy</p>
                          <p className="content-text">
                            The first step to a successful project is to create the concept and
                            strategy for both functional and business purposes by understanding the
                            essence of the brand fully.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="service-item">
                          <span>
                            <i className="fas fa-laptop-code"></i>
                          </span>
                          <p className="content-title">Web Development</p>
                          <p className="content-text">
                            I build web apps and solutions for a variety of business domains
                            including Ecommerce, Data-Visualization, e-Learning, Insurance,
                            Healthcare, Blockchain, Fintech, Multimedia, and Marketing by
                            bulletproof code.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="service-item">
                          <span>
                            <i className="fas fa-mobile-alt"></i>
                          </span>
                          <p className="content-title">Hybrid Development</p>
                          <p className="content-text">
                            I develop cross-platform apps that run on both iOS and Android from a
                            single code base. Hybrid development reduces the time and cost
                            associated with development on both platforms.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="service-item">
                          <span>
                            <i className="fas fa-building"></i>
                          </span>
                          <p className="content-title">MVP Development</p>
                          <p className="content-text">
                            I introduce to the new perspective over the Minimum Viable Product
                            development, Prototyping, and Proof of Concept because I know what your
                            startup needs to succeed.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="service-item">
                          <span>
                            <i className="fas fa-check-double"></i>
                          </span>
                          <p className="content-title">Quality Assuarance</p>
                          <p className="content-text">
                            Regularly I control and evaluate multiple aspects to make sure my
                            progress runs smoothly, my product is well-perform and my result comes
                            out accurately how the client required.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="service-item">
                          <span>
                            <i className="fas fa-server"></i>
                          </span>
                          <p className="content-title">DevOps & Cloud</p>
                          <p className="content-text">
                            I work to build and maintain highly available and reliable
                            infrastructure as well as support you to deliver your digital product or
                            service faster.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!--End Services Section--> */}

        {/* <!--Start Resume Section--> */}
        {/* <section className="resume section pp-scrollable" id="resume">
          <div className="content-container">
            <div className="display-table">
              <div className="display-content">
                <div className="resume-header">
                  <div className="title-small">
                    <p>MY RESUME</p>
                  </div>
                  <h4 className="section-title">My Resume</h4>
                </div>
                <div className="resume-content">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="education">
                          <div className="resume-item">
                            <p className="res-year">2021.05-2021.10</p>
                            <p className="res-title">Full Stack Developer - Arcanium</p>
                            <ul className="resume-list-wrap">
                              <li className="resume-list-item">
                                Technologies: Shopify, Shopify Plus, Liquid, Javascript, Typescript, React.js,
                                Nodejs, Expressjs, Serverless, and AWS Lambda, DynamoDB, Amplify
                              </li>
                            </ul>
                          </div>
                          <div className="resume-item">
                            <p className="res-year">2020.08-2021.03</p>
                            <p className="res-title">Fullstack Developer - Kasaz</p>
                            <ul className="resume-list-wrap">
                              <li className="resume-list-item">
                                Technologies: ReactJS, React Native, Redux, Angular, Ruby on Rails,
                                GraphQL, PostgreSQL, 3rd Party Services, SEO
                              </li>
                            </ul>
                          </div>
                          <div className="resume-item">
                            <p className="res-year">2020.03-2020.06</p>
                            <p className="res-title">Full Stack Mobile Engineer - StartupLandia</p>
                            <ul className="resume-list-wrap">
                              <li className="resume-list-item">
                                Technologies: Flutter, Dart, Material UI, Firebase, Python,
                                PostgreSQL, IOS and Android
                              </li>
                            </ul>
                          </div>
                          <div className="resume-item">
                            <p className="res-year">2018.10-2019.11</p>
                            <p className="res-title">Software Engineer - Digia Technology</p>
                            <ul className="resume-list-wrap">
                              <li className="resume-list-item">
                                Technologies: React, React Native, Redux, D3.js, ThreeJS, GraphQL,
                                Nodejs, Python, Django, Ruby on Rails, CI/CD
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="experience">
                          <div className="resume-item">
                            <p className="res-year">2017.01-2018.08</p>
                            <p className="res-title">
                              Web Developer - Sitback solutions
                            </p>
                            <ul className="resume-list-wrap">
                              <li className="resume-list-item">
                                Technologies: React, Angular, Express, MongoDB, Node, Webpack, SASS
                              </li>
                            </ul>
                          </div>
                          <div className="resume-item">
                            <p className="res-year">2015.07-2017.01</p>
                            <p className="res-title">FullStack Engineer - FleckActives</p>
                            <ul className="resume-list-wrap">
                              <li className="resume-list-item">
                                Technologies: PHP, Laravel, Wordpress, Javascript, AngularJS, Node,
                                Contentful CMS
                              </li>
                            </ul>
                          </div>
                          <div className="resume-item">
                            <p className="res-year">2015.07-2017.01</p>
                            <p className="res-title">
                              Web Application Engineer - Baize Technology Pte Ltd
                            </p>
                            <ul className="resume-list-wrap">
                              <li className="resume-list-item">
                                Technologies: AngularJS, Javascript, HTML5, CSS, MySQL, PHP, Ruby on
                                Rails
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* <!--End Resume Section--> */}

        {/* <!--Start Portfolio Section--> */}
        <section className="portfolio section pp-scrollable" id="portfolio">
          <div className="content-container">
            <div className="display-table">
              <div className="display-content">
                <div className="portfolio-header">
                  <div className="title-small">
                    <p>SEE MY WORKS</p>
                  </div>
                  <h4 className="section-title">Portfolio</h4>
                </div>
                <div className="portfolio-content">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12 col-sm-12">
                        <div className="portfolio-content-head">
                          <ul className="controls">
                            <li className="filter" data-filter="all">
                              All
                            </li>
                            <li className="filter" data-filter=".react">
                              React
                            </li>
                            <li className="filter" data-filter=".angular">
                              Angular
                            </li>
                            <li className="filter" data-filter=".vue">
                              Vue
                            </li>
                            <li className="filter" data-filter=".dataviz">
                              Data Viz
                            </li>
                            <li className="filter" data-filter=".reactnative">
                              React Native
                            </li>
                            <li className="filter" data-filter=".flutter">
                              Flutter
                            </li>
                            <li className="filter" data-filter=".node">
                              Node
                            </li>
                            <li className="filter" data-filter=".shopify">
                              Shopify
                            </li>
                            <li className="filter" data-filter=".python">
                              Python
                            </li>
                            <li className="filter" data-filter=".ruby">
                              Ruby on Rails
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-md-12 col-sm-12">
                        <div className="portfolio-content-items">
                          <div className="row">
                            {portfolioData.map((item, key) => (
                              <PortfolioCard
                                key={key}
                                category={item.category}
                                mainClass={item.mainClass}
                                imgSrc={item.imgSrc}
                                projectUrl={item.projectUrl}
                              />
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!--End Portfolio Section--> */}

        {/* <!--Start work Section--> */}
        <section className="work section pp-scrollable" id="work">
          <div className="content-container">
            <div className="display-table">
              <div className="display-content">
                <div className="work-header">
                  <div className="title-small">
                    <p>WORKING PROCESS</p>
                  </div>
                  <h4 className="section-title">How I Work</h4>
                </div>
                <div className="work-content">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="video-container">
                          <div className="video-area">
                            {/* <img src="web/images/customs/web_dev_process.jpg" alt="web dev process" /> */}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="work-item">
                          <span className="work-title">Discuss &amp; Plan</span>
                          <p>
                            Set Goals, Define Project's Target Audience, Create Sitemap, Create
                            Wireframe/Mock-up, Select Technology Stack
                          </p>
                        </div>
                        <div className="work-arrow"></div>
                        <div className="work-item">
                          <span className="work-title">Design &amp; Develop</span>
                          <p>
                            Create&Review page Layout, Get Client's feedback, Get Content ready for
                            migration, Build&Deploy project, Add special features and interactivity
                          </p>
                        </div>
                        <div className="work-arrow"></div>
                        <div className="work-item">
                          <span className="work-title">Final Approach</span>
                          <p>Testing, Review and Launch, Maintenance and Regular Updating</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!--End work Section--> */}

        {/* <!--Start Client Testimonial Section Area--> */}
        <section className="client-testimonial pp-scrollable section" id="client-testimonial">
          <div className="content-container">
            <div className="display-table">
              <div className="display-content">
                <div className="testimonial-header">
                  <div className="title-small">
                    <p>TESTIMONIAL</p>
                  </div>
                  <h4 className="section-title">What People Say</h4>
                </div>
                <div className="client-area">
                  <div className="container">
                    <div className="row">
                      <div id="owl-demo-testimonial" className="owl-carousel owl-theme">
                        {/* <!--Start Client Single design area--> */}
                        <div className="item">
                          <div className="client-img">
                            {/* <img src="web/images/client/img1.jpg" alt="client" /> */}
                            <span>PS</span>
                          </div>
                          <div className="testimonial-content">
                            <div className="quote-text">
                              <p>
                                <i className="fa fa-quote-left" aria-hidden="true"></i>
                                <span>
                                  Very detail oriented. Xumei showed exceptional care for details
                                  making sure to fully understand all requirements in detail and
                                  setting the system up properly as well as restructuring outdated
                                  components.
                                </span>
                                <i className="fa fa-quote-right" aria-hidden="true"></i>
                              </p>
                              <div className="client-identity">
                                <p className="name">PETER SPECK</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <!--End Client Single design area--> */}
                        {/* <!--Start Client Single design area--> */}
                        <div className="item">
                          <div className="client-img">
                            {/* <img src="web/images/client/img2.jpg" alt="client" /> */}
                            <span>AR</span>
                          </div>
                          <div className="testimonial-content">
                            <div className="quote-text">
                              <p>
                                <i className="fa fa-quote-left" aria-hidden="true"></i>
                                <span>
                                  Xumei was a pleasure to work with. Everything he did was top quality
                                  and delivered ahead of schedule. Communication was excellent. He
                                  understood my requirements very quickly, and offered excellent
                                  suggestions to improve the final output. He checked in regularly
                                  to allow me to provide feedback, and the final deliverable
                                  exceeded my expectations. His code is very clean, well-designed,
                                  and maintainable. I look forward to working with him again in the
                                  future!
                                </span>
                                <i className="fa fa-quote-right" aria-hidden="true"></i>
                              </p>
                              <div className="client-identity">
                                <p className="name">ARTAN RIFATI</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <!--End Client Single design area--> */}
                        {/* <!--Start Client Single design area--> */}
                        <div className="item">
                          <div className="client-img">
                            {/* <img src="web/images/client/img3.jpg" alt="client" /> */}
                            <span>DG</span>
                          </div>
                          <div className="testimonial-content">
                            <div className="quote-text">
                              <p>
                                <i className="fa fa-quote-left" aria-hidden="true"></i>
                                <span>
                                  Xumei exceeded my expectations in every way for my Next Generation
                                  Marketing Analytics Platform platform project. He delivered
                                  extremely robust code and a rather polished end product for an MVP
                                  well ahead of schedule. He also managed a small team that helped
                                  with the development After an initial phone call, he understood
                                  the product I wanted and immediately began giving helpful
                                  suggestions on features and how best to implement the project. I
                                  had regular Skype calls with Xumei, and He was always on time and
                                  true professionals. It was a largely hands-off experience for me,
                                  which was great. I highly recommend Xumei for any development
                                  project.
                                </span>
                                <i className="fa fa-quote-right" aria-hidden="true"></i>
                              </p>
                              <div className="client-identity">
                                <p className="name">DANIEL GOLDMAN</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <!--End Client Single design area--> */}
                        {/* <!--Start Client Single design area--> */}
                        <div className="item">
                          <div className="client-img">
                            {/* <img src="web/images/client/img1.jpg" alt="client" /> */}
                            <span>BD</span>
                          </div>
                          <div className="testimonial-content">
                            <div className="quote-text">
                              <p>
                                <i className="fa fa-quote-left" aria-hidden="true"></i>
                                <span>
                                  Xumei is an excellent senior developer. In my project he both
                                  developed by himself (react-native), and helped me quickly add
                                  capacity by adding members of his own little team of developers. I
                                  can highly recommend him both for his development skills and his
                                  communication/management skills. Will hire again. Thank you Xumei!
                                </span>
                                <i className="fa fa-quote-right" aria-hidden="true"></i>
                              </p>
                              <div className="client-identity">
                                <p className="name">BARRY DISNEY</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <!--End Client Single design area--> */}
                        {/* <!--Start Client Single design area--> */}
                        <div className="item">
                          <div className="client-img">
                            {/* <img src="web/images/client/img2.jpg" alt="client" /> */}
                            <span>SG</span>
                          </div>
                          <div className="testimonial-content">
                            <div className="quote-text">
                              <p>
                                <i className="fa fa-quote-left" aria-hidden="true"></i>
                                <span>
                                  Xumei is amazing developer with all the skills that you would look
                                  for. Everything is communicated on time in clear and concise
                                  manner. The quality of work and determination are outstanding.
                                  Without any hesitation I can recommend Xumei to anyone looking to
                                  hire professional developer. Looking forward to working further.
                                </span>
                                <i className="fa fa-quote-right" aria-hidden="true"></i>
                              </p>
                              <div className="client-identity">
                                <p className="name">SCOTT GALIT</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <!--End Client Single design area--> */}
                        {/* <!--Start Client Single design area--> */}
                        <div className="item">
                          <div className="client-img">
                            {/* <img src="web/images/client/img3.jpg" alt="client" /> */}
                            <span>RT</span>
                          </div>
                          <div className="testimonial-content">
                            <div className="quote-text">
                              <p>
                                <i className="fa fa-quote-left" aria-hidden="true"></i>
                                <span>
                                  Delivered an excellent service that meets beyond your expectation.
                                  Xumei is very capable and proactive to meet your need and complete
                                  your project. Strongly recommend him if you want to get things
                                  done for your project.
                                </span>
                                <i className="fa fa-quote-right" aria-hidden="true"></i>
                              </p>
                              <div className="client-identity">
                                <p className="name">ROBIN TOFT</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <!--End Client Single design area--> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!--End Client Testimonial Section Area--> */}

        {/* <!--Start Contact Section--> */}
        <section className="contact footer pp-scrollable section" id="contact">
          <div className="content-container">
            <div className="display-table">
              <div className="display-content">
                <div className="contact-header">
                  <div className="title-small">
                    <p>CONTACT ME</p>
                  </div>
                  <h4 className="section-title">Get In Touch</h4>
                </div>
                <div className="contact-content">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="contact-detail">
                          <h6>Contact</h6>
                          <p className="">Feel Free To Contact Me Any Time!</p>
                          <p className="contact-text">
                            I always provide technical, creative and business insights to all
                            projects I work on.
                          </p>
                          <p className="phone">
                            <i className="fa fa-phone" aria-hidden="true"></i>
                            <span>Phone:</span>+86 18834122285
                          </p>
                          <p className="adress">
                            <i className="fa fa-map-marker" aria-hidden="true"></i>
                            <span>Location:</span>
                            <span className="adress-loc">China</span>
                          </p>
                          <p className="email">
                            <i className="fas fa-envelope" aria-hidden="true"></i>
                            <span>Email:</span>wangxm19950605@163.com
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="contact-form">
                          <form className="contact-form-area" action="contact.php" method="post">
                            <div className="row">
                              <div className="col-md-6">
                                <input type="text" name="name" placeholder="Name" id="form-name" />
                              </div>
                              <div className="col-md-6">
                                <input
                                  type="text"
                                  name="email"
                                  placeholder="Email"
                                  id="form-email"
                                />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-12">
                                <input
                                  type="text"
                                  name="subject"
                                  placeholder="Subject"
                                  id="form-subject"
                                />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-12">
                                <textarea
                                  placeholder="Type here"
                                  name="message"
                                  id="form-message"
                                ></textarea>
                                <input
                                  type="submit"
                                  className="submit-btn btn-style1 clearfix"
                                  value="Submit"
                                  id="contact-submit"
                                />
                                <div className="result"></div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!--Start Footer--> */}
                <footer>
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="copyright">
                          <p>Copyright © {new Date().getFullYear()} Xumei Wang(王旭梅)</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </footer>
                {/* <!--End Footer--> */}
              </div>
            </div>
          </div>
        </section>
        {/* <!--End Contact Section--> */}
      </div>
    </div>
  );
}

export default App;
